<template>
  <div class="medication-administration-records">
    <ul class="tab-wrap">
      <li v-for="(item,index) in tabList" :key="index" :class="source === item.value ? 'active-bg' : ''"
        @click="changeTab(item)">{{ item.label }}</li>
    </ul>
    <div class="tab-content">
      <div class="data-record" v-if="nowTakeDrug.length>0|| historyTakeDrug.length>0">
        <div class="current-medication">
          <div class="title">当前用药</div>
          <div class="current-medication-table">
            <el-table :data="nowTakeDrug" :max-height="200" v-if="nowTakeDrug && nowTakeDrug.length > 0"
              style="width: 100%">
              <el-table-column prop="typeName" label="添加类型" align="center" v-if="source !== 2">
              </el-table-column>
              <el-table-column prop="startData" label="开始时间" align="center">
              </el-table-column>
              <el-table-column prop="endData" label="结束时间" align="center" v-if="source !== 2">
              </el-table-column>
              <el-table-column prop="drugName" label="药品名称" align="center">
              </el-table-column>
              <el-table-column prop="frequencyName" label="频率" align="center" v-if="source !== 2">
              </el-table-column>
              <el-table-column label="操作" width="100" v-if="source !== 2">
                <template slot-scope="scope">
                  <el-button @click="getDetail(scope.row)" type="text" size="small" :disabled="scope.row.type !== 1">
                    查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="empty" v-else>
              <img src="@/assets/images/medication-empty@2x.png" />
              <span>暂无当前用药记录哦~</span>
            </div>
          </div>
        </div>
        <div class="history-medication">
          <div class="title">历史用药</div>
          <div class="history-medication-table">
            <el-table :data="historyTakeDrug" :max-height="200" v-if="historyTakeDrug && historyTakeDrug.length > 0"
              style="width: 100%">
              <el-table-column prop="typeName" label="添加类型" align="center" v-if="source !== 2">
              </el-table-column>
              <el-table-column prop="startData" label="开始时间" align="center">
              </el-table-column>
              <el-table-column prop="endData" label="结束时间" align="center" v-if="source !== 2">
              </el-table-column>
              <el-table-column prop="drugName" label="药品名称" align="center">
              </el-table-column>
              <el-table-column prop="frequencyName" label="频率" align="center" v-if="source !== 2">
              </el-table-column>
              <el-table-column label="操作" width="100" v-if="source !== 2">
                <template slot-scope="scope">
                  <el-button @click="getDetail(scope.row)" type="text" size="small" :disabled="scope.row.type !== 1">
                    查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="empty" v-else>
              <img src="@/assets/images/medication-empty@2x.png" />
              <span>暂无历史用药记录哦~</span>
            </div>
          </div>
        </div>
      </div>
      <div class="empty" v-else style="background: #fff">
        <img src="@/assets/images/medication-empty@2x.png" />
        <span>暂无用药记录哦~</span>
      </div>
    </div>
    <!-- 用药详情弹框 -->
    <el-dialog title="查看详情" :visible.sync="detailVisible" width="30%" center class="detail-dialog">
      <div class="detail-content">
        <div class="photo">
          <div class="header">
            <p></p>
            <h1>上传照片</h1>
          </div>
          <div class="photo-img" v-if="recordDetail.photo">
            <img :src="`${imgURL}${recordDetail.photo}`" :alt="recordDetail.photo">
          </div>
          <div class="empty" v-else>
            <img src="@/assets/images/service-nobuy.png" />
            <span>患者暂无上传图片</span>
          </div>
        </div>
        <div class="description">
          <div class="header">
            <p></p>
            <h1>剂型规格说明</h1>
          </div>
          <div class="description-content" v-if="recordDetail.dosageForm || recordDetail.specification">
            <div class="content">
              <label>剂型:</label>
              <span>{{ recordDetail.dosageForm }}</span>
            </div>
            <div class="content">
              <label>规格:</label>
              <span>{{ recordDetail.specification }}</span>
            </div>
          </div>
          <div class="empty" v-else>
            <span>患者暂未填写具体说明</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import IM from "../../../treatment/components/IM/IM.vue";
import {
  getPatientTakeDrugsRecordVOByPatientId,
  getPatientTakeDrugsDetail
} from "../../api/treatmentPlan";
import local from "@/utils/local.js";

export default {
  name: "MedicationAdministrationRecords",
  components: {
    IM
  },
  props: {
    userData: {
      type: Object
    },
    patientId: {
      type: String
    }
  },
  watch: {
    patientId: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        console.log('newValue', newValue)
        if (!oldValue || newValue !== oldValue) {
          this.getPatientTakeDrugsRecordVOByPatientId(newValue);
        }
      }
    }
  },
  data() {
    return {
      source: Number(local.get('tabActiveItem')) || 1,
      tabList: [
        {
          label: "患者服药记录",
          value: 1
        },
        {
          label: "小兰用药数据",
          value: 2
        }
      ],
      activeTab: "患者服药记录",
      historyTakeDrug: [],
      nowTakeDrug: [],
      detailVisible: false,
      recordDetail: {},
      imgURL: process.env.VUE_APP_OSS_URL, //医生历史图片接受路径
    };
  },
  methods: {
    changeTab(item) {
      this.source = item.value;
      local.set('tabActiveItem', item.value);// 存储子tab
      this.getPatientTakeDrugsRecordVOByPatientId(this.userData.patientId);
    },
    async getPatientTakeDrugsRecordVOByPatientId(patientId) {
      let {
        code,
        data: { historyTakeDrug, nowTakeDrug }
      } = await getPatientTakeDrugsRecordVOByPatientId({
        patientId,
        source: this.source
      });
      if (code === 0) {
        this.historyTakeDrug = historyTakeDrug
          ? historyTakeDrug.map(item => {
              return {
                ...item,
                typeName:
                  item.type === 1
                    ? "自主添加"
                    : item.type === 2
                    ? "疗管添加"
                    : "-"
              };
            })
          : [];
        this.nowTakeDrug = nowTakeDrug
          ? nowTakeDrug.map(item => {
              return {
                ...item,
                typeName:
                  item.type === 1
                    ? "自主添加"
                    : item.type === 2
                    ? "疗管添加"
                    : "-"
              };
            })
          : [];
      }
    },
    // 获取用药详情
    async getDetail(row) {
      let { code, data } = await getPatientTakeDrugsDetail(row.id);
      if (code === 0) {
        this.detailVisible = true;
        this.recordDetail = data;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.medication-administration-records {
  height: calc(100% - 138px);
  // background: #ffffff;
  .tab-wrap {
    display: flex;
    background-color: #fff;
    padding: 16px;
    border-radius: 6px;
    li {
      font-size: 14px;
      color: #333333;
      border-radius: 4px;
      padding: 5px 10px;
      margin-right: 20px;
      cursor: pointer;
    }
  }
  .active-bg {
    background-color: #1a7bfc;
    color: #fff !important;
  }

  .tab-content {
    height: calc(100% - 76px);
  }

  .data-record {
    height: 100%;
    background: #fff;
    // margin-top: 16px;
    padding: 16px;
    .current-medication,
    .history-medication {
      .title {
        font-size: 14px;
        color: #333333;
        margin-bottom: 14px;
      }
    }
    .history-medication {
      margin-top: 50px;
    }
  }
  .empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 15px 0;
    img {
      width: 163px;
    }
    span {
      color: #333333;
      margin-top: 10px;
    }
  }
  .detail-dialog {
    .header {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      p {
        width: 4px;
        height: 15px;
        background: #1a7bfc;
        margin-right: 12px;
      }

      h1 {
        font-size: 14px;
        font-weight: bolder;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
      }
    }
    .photo {
      margin-bottom: 40px;
      .photo-img {
        width: 100%;
        img {
          width: 100%;
        }
      }
    }

    .description {
      .description-content {
        .content {
          color: #333333;
          margin-bottom: 20px;
          label {
            margin-right: 20px;
          }
        }
      }
    }
  }
}

/deep/.el-table__header-wrapper {
  background-color: #fafafa;
}
/deep/.el-table th > .cell {
  color: #333;
  font-weight: bold;
}
/deep/.el-table th {
  background: #fafafa;
}
</style>